import axios from 'axios';
import { getApiBaseUrl } from '../config/apiUrl';

const API_URL = getApiBaseUrl();

// Flag to prevent multiple redirects
let isRedirecting = false;

// Axios instance with auth header
const api = axios.create({
  baseURL: API_URL,
});

// Add auth token to requests (except for public endpoints)
api.interceptors.request.use((config) => {
  // Don't add token for public endpoints
  const isPublicEndpoint = config.url?.includes('/public/') ||
                          config.url?.includes('/quotes/public/') ||
                          config.url?.includes('/storefront/') ||
                          config.url?.includes('/locations/');
  const isAuthFlowEndpoint = config.url?.includes('/auth/login') ||
                            config.url?.includes('/auth/register') ||
                            config.url?.includes('/auth/2fa/verify');

  if (!isPublicEndpoint && !isAuthFlowEndpoint) {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect to login if we're on a public page or making a public API call
      const isPublicPage = window.location.pathname.startsWith('/public/') ||
        window.location.pathname.startsWith('/store/') ||
        window.location.pathname.startsWith('/product/') ||
        window.location.pathname.startsWith('/blog') ||
        window.location.pathname.startsWith('/hakkimizda') ||
        window.location.pathname.startsWith('/yasal/') ||
        (process.env.REACT_APP_PUBLIC_SITE === 'true' && window.location.pathname === '/');
      const isPublicApiCall = error.config?.url?.includes('/public/') ||
                             error.config?.url?.includes('/quotes/public/') ||
                             error.config?.url?.includes('/storefront/') ||
                             error.config?.url?.includes('/locations/');
      const isLoginPage = window.location.pathname === '/login' || 
                         window.location.pathname === '/register';
      
      // Only redirect if not already redirecting, not on public/login pages, and not a public API call
      if (!isPublicPage && !isPublicApiCall && !isLoginPage && !isRedirecting) {
        isRedirecting = true;
        localStorage.removeItem('token');
        // Use replace to prevent back button issues
        window.location.replace('/login');
      }
    }
    return Promise.reject(error);
  }
);

export default api; 